import { GetStaticProps } from 'next';
import { useTranslation } from 'next-i18next';

import { EmployerSecondaryLayout } from '../../../layouts';
import { getServerTranslations } from '../../../get-server-side-translations';
import DashboardPageContent from '../../../components/dashboard/dashboard-page-content';

function DashboardPage() {
  const { t } = useTranslation('dashboard-page');

  return (
    <EmployerSecondaryLayout pageTitle={t('dashboard')}>
      <DashboardPageContent />
    </EmployerSecondaryLayout>
  );
}
export default DashboardPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const translation = await getServerTranslations(locale, [
    'common',
    'dashboard-page',
    'job-positions-page',
    'jp-onboarding',
    'product-description-page',
    'restaurant-details-page',
  ]);
  return {
    props: {
      ...translation,
    },
  };
};
